import { useEffect } from 'react';

interface UseParentNotificationsAllProps {
  serviceTableDataByFreelancer: { [key: string]: any };
  pensionDataByFreelancer: { [key: string]: any };
  holidayDataByFreelancer: { [key: string]: any };
  deductionsByFreelancer: { [key: string]: any[] };
  removedCopiedWorkingHours: Set<number>;
  calculatedSubAmount?: any;
  onServiceTableDataByFreelancerChange?: (data: { [key: string]: any }) => void;
  onPensionDataByFreelancerChange?: (data: { [key: string]: any }) => void;
  onHolidayDataByFreelancerChange?: (data: { [key: string]: any }) => void;
  onDeductionsByFreelancerChange?: (data: { [key: string]: any[] }) => void;
  onRemovedCopiedWorkingHoursChange?: (data: Set<number>) => void;
  onCalculatedSubAmountChange?: (data: any) => void;
}

export const useParentNotificationsAll = ({
  serviceTableDataByFreelancer,
  pensionDataByFreelancer,
  holidayDataByFreelancer,
  deductionsByFreelancer,
  removedCopiedWorkingHours,
  calculatedSubAmount,
  onServiceTableDataByFreelancerChange,
  onPensionDataByFreelancerChange,
  onHolidayDataByFreelancerChange,
  onDeductionsByFreelancerChange,
  onRemovedCopiedWorkingHoursChange,
  onCalculatedSubAmountChange,
}: UseParentNotificationsAllProps) => {
  
  useEffect(() => {
    onServiceTableDataByFreelancerChange?.(serviceTableDataByFreelancer);
  }, [serviceTableDataByFreelancer, onServiceTableDataByFreelancerChange]);

  useEffect(() => {
    onPensionDataByFreelancerChange?.(pensionDataByFreelancer);
  }, [pensionDataByFreelancer, onPensionDataByFreelancerChange]);

  useEffect(() => {
    onHolidayDataByFreelancerChange?.(holidayDataByFreelancer);
  }, [holidayDataByFreelancer, onHolidayDataByFreelancerChange]);

  useEffect(() => {
    onDeductionsByFreelancerChange?.(deductionsByFreelancer);
  }, [deductionsByFreelancer, onDeductionsByFreelancerChange]);

  useEffect(() => {
    onRemovedCopiedWorkingHoursChange?.(removedCopiedWorkingHours);
  }, [removedCopiedWorkingHours, onRemovedCopiedWorkingHoursChange]);

  useEffect(() => {
    onCalculatedSubAmountChange?.(calculatedSubAmount);
  }, [calculatedSubAmount, onCalculatedSubAmountChange]);
};
